import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = 'https://stu148664.webhosting.arden.ac.uk/COM6008/api';

export const fetchDashboardAnalytics = createAsyncThunk('analytics/dashboard', async (timeframe = 'month') => {
  const { data } = await axios.get(`${API_BASE_URL}/analytics/dashboard`, { params: { timeframe } });
  return data;
});

export const fetchSpendingPatterns = createAsyncThunk('analytics/spendingPatterns', async () => {
  const { data } = await axios.get(`${API_BASE_URL}/analytics/spending-patterns`);
  return data;
});

export const fetchFinancialInsights = createAsyncThunk('analytics/insights', async () => {
  const { data } = await axios.get(`${API_BASE_URL}/analytics/insights`);
  return data;
});

export const fetchPredictions = createAsyncThunk('analytics/predictions', async () => {
  const { data } = await axios.get(`${API_BASE_URL}/analytics/predictions`);
  return data;
});

const initialState = {
  dashboard: { totalIncome: 0, totalExpenses: 0, netIncome: 0, trends: [] },
  spendingPatterns: { categories: [], timeOfDay: [], dayOfWeek: [] },
  insights: { recommendations: [], alerts: [], healthScore: 0 },
  predictions: { nextMonthExpenses: 0, savingsGoalProgress: 0, budgetForecasts: [] },
  loading: { dashboard: false, patterns: false, insights: false, predictions: false },
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
    updateHealthScore: (state, action) => { state.insights.healthScore = action.payload; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardAnalytics.fulfilled, (state, action) => { 
        state.dashboard = action.payload; 
      })
      .addCase(fetchSpendingPatterns.fulfilled, (state, action) => { 
        state.spendingPatterns = action.payload; 
      })
      .addCase(fetchFinancialInsights.fulfilled, (state, action) => { 
        state.insights = action.payload; 
      })
      .addCase(fetchPredictions.fulfilled, (state, action) => { 
        state.predictions = action.payload; 
      });
  },
});

export const { clearError, updateHealthScore } = analyticsSlice.actions;
export const selectDashboardAnalytics = (state) => state.analytics.dashboard;
export const selectSpendingPatterns = (state) => state.analytics.spendingPatterns;
export const selectFinancialInsights = (state) => state.analytics.insights;
export const selectPredictions = (state) => state.analytics.predictions;
export default analyticsSlice.reducer; 